<template>
  <div>
    <!-- <div class="member_tabbar">
      <a href="javascript:;" :class="{'active': curTitle == 1}" @click="changeTitle(1)">学习记录<i></i></a>
      <a href="javascript:;" :class="{'active': curTitle == 2}" @click="changeTitle(2)">我的收藏<i></i></a>
    </div> -->
    <accnav
      :list="navList"
      :curTitleId="curTitleId"
      @titleChange="titleChange"
    ></accnav>
    <div>
      <component :is="child"></component>
    </div>
  </div>
</template>

<script>
import {ApiGetTaskList} from '../../net/accound/index.js'
import accnav from '../../common/accnav.vue'
import avatar from './children/avatar.vue'
import password from './children/password.vue'
export default {
  data: function () {
    return {
      curTitleId: 1, //  1 修改头像   2 修改密码  
      navList: [{
        id: 1,
        name: '修改头像',
      },{ 
        id: 2,
        name: '修改密码',
      }],
      loading: false,
    }
  },
  computed: {
    child: function () {
      switch (this.curTitleId) {
        case 1:
         return avatar
         break
        case 2:
         return password
         break
      }
    }
  },
  components:{accnav},
  methods:{
    titleChange: function (id) {
      this.curTitleId = id
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AccSetting/AccSetting.vue